import React, {HTMLAttributes, useEffect, useRef, useState} from 'react';

enum ScrollState {
  VISIBLE,
  INVISIBLE,
}

interface Props {
  onScrollAppear: () => void;
  onScrollDisappear: () => void;
  maxHeight: number;
}

const ScrollAlerter: React.FC<Props & HTMLAttributes<any>> = ({
  onScrollAppear,
  onScrollDisappear,
  maxHeight,
  children,
  ...props
}) => {
  const [lastScrollState, setLastScrollState] = useState<ScrollState>(ScrollState.INVISIBLE);

  const outer = useRef<HTMLDivElement>(null);
  const inner = useRef<HTMLDivElement>(null);

  // mac seemingly sometimes shows a difference here even though
  // osx likes to hide the scroller / not cause it to impact page width.
  // who knows
  const fudge = 1;

  useEffect(() => {
    const outerWidth = outer?.current?.clientWidth ?? 0;
    const innerWidth = inner?.current?.scrollWidth ?? 0;

    const diff = Math.abs(outerWidth - innerWidth);

    if (diff > fudge && lastScrollState === ScrollState.INVISIBLE) {
      setLastScrollState(ScrollState.VISIBLE);
      onScrollAppear();
    } else if (diff <= fudge && lastScrollState === ScrollState.VISIBLE) {
      setLastScrollState(ScrollState.INVISIBLE);
      onScrollDisappear();
    }
  }, [lastScrollState, onScrollAppear, onScrollDisappear]);

  return (
    <div ref={outer} {...props}>
      <div ref={inner} style={{overflowY: 'auto', maxHeight: maxHeight}}>
        {children}
      </div>
    </div>
  );
};

export default ScrollAlerter;
